import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CaseRecommendationState, RecommendedCases } from '../types';

const initialState: CaseRecommendationState = {
  isModalOpen: false,
  onStartCallingCallback: undefined,
  recommendedCases: {
    lastRefreshedInMs: 0,
    caseList: []
  },
  currentRecommendedCase: {
    customerReferenceId: '',
    customerName: '',
    entityId: '',
    caseReferenceId: '',
    businessVertical: '',
    priority: 0,
    totalCases: 0,
    attributes: {
      customerName: '',
      latestDisposition: '',
      ptpState: '',
      isContactable: false,
      latestInteractionTimestamp: 0
    }
  },
  recommendedMetadata: {
    totalCases: 0,
    visitedCases: 0,
    pendingPtps: 0,
    lastRefreshedInMs: 0
  },
  isLoadingRecommendedCases: false
};

const CaseRecommendationSlice = createSlice({
  name: 'caseRecommendation',
  initialState,
  reducers: {
    setRecommendedMetadata: (state, action) => {
      state.recommendedMetadata = action.payload;
    },
    setRecommendedCases: (state, action) => {
      state.recommendedCases = action.payload;
    },
    appendRecommendedCases: (state, action: PayloadAction<RecommendedCases>) => {
      state.recommendedCases.caseList = [
        ...state.recommendedCases.caseList,
        ...action.payload.caseList
      ];
      state.recommendedCases.lastRefreshedInMs = action.payload.lastRefreshedInMs;
    },
    setRecommendedCasesLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoadingRecommendedCases = action.payload;
    },
    setCurrentRecommendedCase: (state, action) => {
      state.currentRecommendedCase = action.payload;
    },
    openRecommendedModal: state => {
      state.isModalOpen = true;
    },
    closeRecommendedModal: state => {
      state.isModalOpen = false;
      state.onStartCallingCallback = undefined;
    },
    setRecommendedModalCallback: (state, action: PayloadAction<string>) => {
      state.onStartCallingCallback = action.payload;
    }
  }
});

export const {
  openRecommendedModal,
  closeRecommendedModal,
  setRecommendedModalCallback,
  setRecommendedCases,
  appendRecommendedCases,
  setRecommendedCasesLoading,
  setCurrentRecommendedCase,
  setRecommendedMetadata
} = CaseRecommendationSlice.actions;

export default CaseRecommendationSlice.reducer;
